var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { formatBreadcrumb } from '@common/api/category';
import request from '@common/application/utils/request';
import { API_MAP } from './api-map';
export class ProductDetailApi {
    /**
     * 通过 csku 获取商品详情
     */
    static byCSKU(params, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return request
                .get(API_MAP.PRODUCT_DETAIL, {
                csku: params.csku,
                goodsSpec: params === null || params === void 0 ? void 0 : params.goodsSpec
            }, config)
                .then((data) => {
                var _a;
                if ((_a = data.offlineCategoryAttributeVo.attributeList) === null || _a === void 0 ? void 0 : _a.length) {
                    // 分类特有属性过滤
                    // see https://jira.co-mall.com/browse/DCH-4892
                    data.offlineCategoryAttributeVo.attributeList =
                        data.offlineCategoryAttributeVo.attributeList.filter((item) => {
                            // 所有语言的值都等于 'Product Type' 时过滤该属性
                            return Object.values(item.nameMap).some((v) => v !== 'Product Type');
                        });
                }
                return data;
            });
        });
    }
    /**
     * 通过 csku 获取商详面包屑
     */
    static getBreadcrumb(csku, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return request
                .get(API_MAP.PRODUCT_DETAIL_BREADCRUMB, {
                csku
            }, config)
                .then((res) => formatBreadcrumb(res, config));
        });
    }
    /**
     * 获取推荐商品
     */
    static getRecommendProducts(params, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return request.get(API_MAP.PRODUCT_RECOMMEND_PRODUCTS, params, config);
        });
    }
    /**
     * 获取商品评论
     */
    static getProductEvaluation(params, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return request.get(API_MAP.PRODUCT_EVALUATION, Object.assign({}, params), config);
        });
    }
    /**
     * 获取商品 seo 配置
     */
    static getProductSeoConfig(params, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return request.get(API_MAP.PRODUCT_SEO_CONFIG, params, config);
        });
    }
    /**
     * 获取搭配商品
     */
    static getMatchingProducts(params, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return request.get(API_MAP.MATCHING_PRODUCTS, params, config);
        });
    }
    /**
     * 到货通知
     */
    static arrivalNotice(params, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return request.post(API_MAP.DELIVERY_NOTICE, params, config);
        });
    }
}
